/* ============================================
   [NP] カート追加トースト
   株式会社ニューポート 2026-09-16

   カート設定が「ページ」のため、カートに追加してもドロワーが開かず
   ボタンの ✓ が 0.8 秒光るだけだった。テーマ本体（product-form.js /
   quick-add.js など）が発火する cart:update（CartAddEvent）を拾って
   「カートに追加しました / カートを見る」のトーストを 5 秒出す。
   /cart/add は自前で叩かない。失敗時（didError）は出さない。
   スタイルは np-sticky-atc.css 末尾の .np-toast。

   ※ cart:update は数量変更・削除（cart-items-component）や
     段階GWP（np-gwp-tiers.js）の付与・削除でも同名で飛ぶため、
     それらの source と /cart ページ上では出さない。
   ============================================ */
(function () {
  var el, timer;
  var SKIP_SOURCES = ['cart-items-component', 'quick-order-remove-all', 'np-gwp'];

  function onCartPage() { return /^\/cart(\/|$)/.test(location.pathname); }

  function toast() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'np-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="np-toast__msg">カートに追加しました</span>' +
      '<a class="np-toast__link" href="/cart">カートを見る</a>' +
      '<button type="button" class="np-toast__close" aria-label="閉じる">×</button>';
    el.querySelector('.np-toast__close').addEventListener('click', hide);
    document.body.appendChild(el);
    return el;
  }

  function show() {
    toast().classList.add('np-toast--in');
    clearTimeout(timer);
    timer = setTimeout(hide, 5000);
  }

  function hide() {
    if (el) el.classList.remove('np-toast--in');
  }

  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {};
    if (d.didError) return;                          // 追加失敗（上限超過など）
    if (SKIP_SOURCES.indexOf(d.source) !== -1) return; // 数量変更・削除・サンプル付与
    if (onCartPage()) return;                        // カートページでは不要
    show();
  });
})();
